var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.67676 6.25L5.20801 7.71875L9.97884 12.5L5.20801 17.2812L6.67676 18.75L12.9268 12.5L6.67676 6.25Z",
    fill: "url(#paint0_linear_149_2718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.542 6.25L12.0732 7.71875L16.8441 12.5L12.0732 17.2812L13.542 18.75L19.792 12.5L13.542 6.25Z",
    fill: "url(#paint1_linear_149_2718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_2718",
    x1: 12.0776,
    y1: 157.953,
    x2: -3.81909,
    y2: -134.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_2718",
    x1: 18.9429,
    y1: 157.953,
    x2: 3.04615,
    y2: -134.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4b2c859d5a0046f33d5c7f8bdcf866c9.svg";
export { ForwardRef as ReactComponent };